import { useState, useEffect } from "react";

// GenerIA Logo
const GENERIA_LOGO = "https://customer-assets.emergentagent.com/job_inspeccion-pwa/artifacts/qhvfjidw_IMG_8814.jpeg";

const B = {
  blue: "#0066FF",
  orange: "#FF6B00",
  cyan: "#00CFFF",
  bg: "#060C18",
  bgCard: "#0D1526",
  bgCardHover: "#111D35",
  text: "#F0F4FF",
  muted: "#6B7FA3",
  border: "#1A2740",
  green: "#00FF88",
};

const css = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;600;700;800;900&family=Space+Mono:wght@400;700&display=swap');
*{margin:0;padding:0;box-sizing:border-box;}
html{scroll-behavior:smooth;}
body{background:${B.bg};color:${B.text};font-family:'Sora',sans-serif;overflow-x:hidden;}
::-webkit-scrollbar{width:3px;}
::-webkit-scrollbar-thumb{background:${B.blue};border-radius:2px;}

@keyframes fadeUp{from{opacity:0;transform:translateY(28px)}to{opacity:1;transform:translateY(0)}}
@keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}
@keyframes glow{0%,100%{box-shadow:0 0 20px rgba(0,102,255,.3)}50%{box-shadow:0 0 50px rgba(0,102,255,.6),0 0 100px rgba(0,207,255,.15)}}
@keyframes blink{0%,100%{opacity:1}50%{opacity:0}}
@keyframes gridScroll{0%{transform:translateY(0)}100%{transform:translateY(60px)}}
@keyframes scan{0%{top:-4px;opacity:.8}100%{top:100%;opacity:0}}
@keyframes slideIn{from{opacity:0;transform:translateY(-10px)}to{opacity:1;transform:translateY(0)}}
@keyframes pulse{0%,100%{opacity:1}50%{opacity:.5}}

.fu{animation:fadeUp .65s ease forwards;}
.d1{animation-delay:.05s;opacity:0}
.d2{animation-delay:.15s;opacity:0}
.d3{animation-delay:.28s;opacity:0}
.d4{animation-delay:.42s;opacity:0}
.d5{animation-delay:.58s;opacity:0}

.btn{border:none;border-radius:7px;font-family:'Sora',sans-serif;font-weight:700;cursor:pointer;transition:all .2s;letter-spacing:.01em;}
.btn-p{background:${B.blue};color:#fff;padding:15px 32px;font-size:15px;animation:glow 3s ease-in-out infinite;}
.btn-p:hover{background:#0052CC;transform:translateY(-2px);}
.btn-s{background:transparent;color:${B.text};border:1px solid ${B.border};padding:15px 32px;font-size:15px;}
.btn-s:hover{border-color:${B.blue};color:${B.blue};}
.btn-sm{padding:11px 22px;font-size:13px;}

.tag{display:inline-flex;align-items:center;gap:6px;padding:5px 13px;border-radius:100px;font-size:11px;font-weight:700;letter-spacing:.07em;text-transform:uppercase;}
.tag-b{background:rgba(0,102,255,.12);color:${B.cyan};border:1px solid rgba(0,102,255,.28);}
.tag-o{background:rgba(255,107,0,.12);color:${B.orange};border:1px solid rgba(255,107,0,.28);}
.tag-g{background:rgba(0,255,136,.1);color:${B.green};border:1px solid rgba(0,255,136,.22);}
.tag-p{background:rgba(160,100,255,.12);color:#B085FF;border:1px solid rgba(160,100,255,.28);}

.card{background:${B.bgCard};border:1px solid ${B.border};border-radius:12px;padding:26px;transition:all .25s;}
.card:hover{border-color:rgba(0,102,255,.4);background:${B.bgCardHover};transform:translateY(-3px);}

.sec{padding:96px 24px;max-width:1080px;margin:0 auto;}
.div{height:1px;background:linear-gradient(90deg,transparent,${B.border},transparent);}
.mono{font-family:'Space Mono',monospace;}

input,textarea,select{background:rgba(255,255,255,.04);border:1px solid ${B.border};color:${B.text};padding:13px 16px;border-radius:8px;font-family:'Sora',sans-serif;font-size:14px;width:100%;transition:border-color .2s;outline:none;}
input:focus,textarea:focus,select:focus{border-color:${B.blue};}
input::placeholder,textarea::placeholder{color:${B.muted};}
select option{background:#0D1526;}
label{display:block;font-size:11px;font-weight:700;color:${B.muted};letter-spacing:.06em;text-transform:uppercase;margin-bottom:7px;}

.modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,.75);backdrop-filter:blur(8px);z-index:1000;display:flex;align-items:center;justify-content:center;padding:20px;animation:slideIn .2s ease;}
.modal-box{background:#0D1526;border:1px solid ${B.border};border-radius:16px;padding:36px;max-width:520px;width:100%;max-height:90vh;overflow-y:auto;position:relative;}

.grid2{display:grid;grid-template-columns:1fr 1fr;gap:20px;}
.grid3{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;}

@media(max-width:768px){
.grid2,.grid3{grid-template-columns:1fr;}
.hero-t{font-size:36px!important;}
.hide-m{display:none!important;}
.hero-section{min-height:100vh;min-height:100dvh;display:flex;align-items:center;justify-content:center;}
.hero-content{grid-template-columns:1fr!important;text-align:center;padding:40px 20px!important;}
.hero-content>div:first-child{display:flex;flex-direction:column;align-items:center;}
.hero-buttons{justify-content:center!important;}
}
`;

// ── PHONE MOCK ─────────────────────────────────────────────────────────
function PhoneH() {
  const steps = [
    { n: "01", label: "Toma la foto", icon: "📸" },
    { n: "02", label: "Marca la figura", icon: "📐" },
    { n: "03", label: "Captura medidas", icon: "📏" },
    { n: "04", label: "PDF listo", icon: "📄" },
  ];
  const [a, setA] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setA((p) => (p + 1) % steps.length), 2000);
    return () => clearInterval(t);
  }, []);

  return (
    <div style={{ animation: "float 4s ease-in-out infinite", display: "flex", justifyContent: "center" }}>
      <div style={{
        width: 340, height: 200,
        background: "#080F1E",
        border: `2px solid ${B.border}`,
        borderRadius: 20,
        padding: 16,
        position: "relative",
        boxShadow: `0 0 60px rgba(0,102,255,.2)`,
      }}>
        <div style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", width: 5, height: 40, background: B.border, borderRadius: 3 }} />
        <div style={{ marginLeft: 12, height: "100%", display: "flex", flexDirection: "column", gap: 8 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ fontSize: 9, color: B.muted, fontFamily: "Space Mono" }}>TU CONTRATO</div>
            <div style={{ fontSize: 9, color: B.green, fontFamily: "Space Mono" }}>● SEMANA EN CURSO</div>
          </div>
          <div style={{ flex: 1, background: "#101824", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 6, position: "relative", overflow: "hidden" }}>
            <div style={{ fontSize: 32 }}>{steps[a].icon}</div>
            <div style={{ fontFamily: "Space Mono", fontSize: 8, color: B.cyan }}>{steps[a].n}</div>
            <div style={{ fontSize: 10, fontWeight: 700, color: B.text }}>{steps[a].label}</div>
            <div style={{ position: "absolute", left: 0, right: 0, height: 2, background: `linear-gradient(90deg, transparent, ${B.cyan}66, transparent)`, animation: "scan 2s linear infinite" }} />
          </div>
          <div style={{ display: "flex", justifyContent: "center", gap: 5 }}>
            {steps.map((_, i) => (
              <div key={i} style={{ width: i === a ? 16 : 5, height: 5, borderRadius: 3, background: i === a ? B.blue : B.border, transition: "all .3s" }} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// ── PDF MOCK ───────────────────────────────────────────────────────────
function PDFMock() {
  return (
    <div style={{ background: "#080F1E", border: `1px solid ${B.border}`, borderRadius: 10, padding: 20, fontFamily: "Space Mono", fontSize: 10, color: B.muted, position: "relative", overflow: "hidden" }}>
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg,${B.blue},${B.cyan})` }} />
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
        <div>
          <div style={{ color: B.blue, fontWeight: 700, fontSize: 11, marginBottom: 3 }}>GENERADOR DE OBRA</div>
          <div style={{ color: B.text, fontSize: 10 }}>TU CONTRATO · TU OBRA</div>
          <div>Semana en curso</div>
        </div>
        <div style={{ background: "rgba(0,255,136,.1)", border: "1px solid rgba(0,255,136,.3)", color: B.green, padding: "3px 8px", borderRadius: 4, fontSize: 9, fontWeight: 700, alignSelf: "flex-start" }}>✓ PDF LISTO</div>
      </div>
      <div style={{ height: 1, background: B.border, marginBottom: 10 }} />
      {[["2.1.3", "Bacheo", "247.50 m²", "$1,237,500"], ["2.1.4", "Carpeta asfáltica", "183.20 m²", "$916,000"], ["3.2.1", "Guarnición", "94.00 ml", "$188,000"]].map(([k, d, q, a]) => (
        <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "7px 0", borderBottom: `1px solid rgba(26,39,64,.5)` }}>
          <span style={{ color: B.cyan }}>{k}</span>
          <span style={{ flex: 1, margin: "0 10px", color: B.text }}>{d}</span>
          <span>{q}</span>
          <span style={{ color: B.orange, marginLeft: 12 }}>{a}</span>
        </div>
      ))}
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10, paddingTop: 10, borderTop: `1px solid ${B.blue}` }}>
        <span>TOTAL SEMANA</span>
        <span style={{ color: B.blue, fontWeight: 700, fontSize: 12 }}>$2,341,500 MXN</span>
      </div>
    </div>
  );
}

// ── MODAL BASE ─────────────────────────────────────────────────────────
function Modal({ onClose, children }) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box">
        <button onClick={onClose} style={{ position: "absolute", top: 16, right: 16, background: "none", border: "none", color: B.muted, fontSize: 20, cursor: "pointer" }}>✕</button>
        {children}
      </div>
    </div>
  );
}

// ── VIDEO MODAL ────────────────────────────────────────────────────────
function VideoModal({ onClose }) {
  return (
    <Modal onClose={onClose}>
      <iframe 
        src="https://www.youtube-nocookie.com/embed/pg2M2B7FLZ8?si=m9Vvex801ZeO4e2_" 
        style={{width:"100%",aspectRatio:"16/9",border:0}} 
        allowFullScreen
        title="GenerIA Demo"
      />
    </Modal>
  );
}

// ── CONTRATISTA MODAL ──────────────────────────────────────────────────
function ContratistaModal({ onClose }) {
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({ contratos_activos: "", contratos_año: "", alcaldia: "", residentes: "" });

  const waCTA = () => {
    const msg = encodeURIComponent(`Hola, soy contratista y me interesa GenerIA.\n\nContratos activos: ${form.contratos_activos}\nContratos por año: ${form.contratos_año}\nAlcaldía: ${form.alcaldia}\nResidentes: ${form.residentes}`);
    window.open(`https://wa.me/5215650192332?text=${msg}`, "_blank");
  };

  return (
    <Modal onClose={onClose}>
      {step === 0 && (
        <>
          <div className="tag tag-b" style={{ marginBottom: 20 }}>Para contratistas</div>
          <h3 style={{ fontSize: 24, fontWeight: 800, marginBottom: 12, lineHeight: 1.2 }}>GenerIA convierte tus fotos de obra en documentos de cobro.</h3>
          <p style={{ color: B.muted, fontSize: 14, lineHeight: 1.7, marginBottom: 24 }}>
            Toma la foto en obra, marca la figura, captura medidas y listo — tu generador en PDF en minutos. Sin papel, sin Excel, sin AutoCAD, sin rollos.
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 28 }}>
            {["De la foto al PDF en minutos", "Sin papel, sin AutoCAD, sin Excel", "Elimina la barrera más antigua para tramitar tus pagos", "Acceso a GenerIA Oportunidades incluido"].map(b => (
              <div key={b} style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 14 }}>
                <span style={{ color: B.green, fontSize: 16 }}>✓</span>
                <span style={{ color: B.text }}>{b}</span>
              </div>
            ))}
          </div>
          <button className="btn btn-p" style={{ width: "100%" }} onClick={() => setStep(1)}>Me interesa → cuéntame más</button>
        </>
      )}

      {step === 1 && (
        <>
          <div className="tag tag-b" style={{ marginBottom: 20 }}>Cuéntanos de tu operación</div>
          <h3 style={{ fontSize: 20, fontWeight: 800, marginBottom: 20 }}>Para darte la mejor propuesta, necesitamos conocerte.</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 16, marginBottom: 24 }}>
            <div>
              <label>¿Cuántos contratos tienes activos ahorita?</label>
              <select value={form.contratos_activos} onChange={e => setForm({ ...form, contratos_activos: e.target.value })}>
                <option value="">Selecciona</option>
                <option>1</option><option>2-3</option><option>4-6</option><option>7 o más</option>
              </select>
            </div>
            <div>
              <label>¿Cuántos contratos manejas en promedio al año?</label>
              <select value={form.contratos_año} onChange={e => setForm({ ...form, contratos_año: e.target.value })}>
                <option value="">Selecciona</option>
                <option>1-3</option><option>4-10</option><option>11-20</option><option>Más de 20</option>
              </select>
            </div>
            <div>
              <label>¿En qué alcaldía o dependencia trabajas principalmente?</label>
              <input placeholder="Ej. Coyoacán, Obras Públicas CDMX..." value={form.alcaldia} onChange={e => setForm({ ...form, alcaldia: e.target.value })} />
            </div>
            <div>
              <label>¿Cuántos residentes tiene tu equipo?</label>
              <select value={form.residentes} onChange={e => setForm({ ...form, residentes: e.target.value })}>
                <option value="">Selecciona</option>
                <option>1</option><option>2-5</option><option>6-10</option><option>Más de 10</option>
              </select>
            </div>
          </div>
          <button className="btn btn-p" style={{ width: "100%" }} onClick={() => setStep(2)}>Ver mi propuesta →</button>
        </>
      )}

      {step === 2 && (
        <>
          <div className="tag tag-g" style={{ marginBottom: 20 }}>
            <span style={{ width: 6, height: 6, borderRadius: "50%", background: B.green, animation: "blink 1s ease-in-out infinite" }} />
            Early Adopter — lugares limitados
          </div>
          <h3 style={{ fontSize: 22, fontWeight: 800, marginBottom: 12, lineHeight: 1.2 }}>Los primeros 10 construyen GenerIA con nosotros.</h3>
          <p style={{ color: B.muted, fontSize: 14, lineHeight: 1.7, marginBottom: 20 }}>
            18 meses al precio más bajo + un feature a la medida de tu operación, sin costo adicional. Después de estos 10 lugares, eso ya no es parte del trato.
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 28 }}>
            {["Precio de lanzamiento por 18 meses", "Un feature personalizado sin costo extra", "Línea directa con el equipo fundador", "Acceso total GenerIA + Oportunidades"].map(b => (
              <div key={b} style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 14 }}>
                <span style={{ color: B.green, fontSize: 16 }}>✓</span>
                <span style={{ color: B.text }}>{b}</span>
              </div>
            ))}
          </div>
          <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
            {Array.from({ length: 10 }).map((_, i) => (
              <div key={i} style={{ flex: 1, height: 6, borderRadius: 3, background: B.border }} />
            ))}
          </div>
          <div style={{ fontSize: 12, color: B.muted, marginBottom: 20 }}>Primeros cupos disponibles — solo 10 lugares</div>
          <button className="btn btn-p" style={{ width: "100%", marginBottom: 10 }} onClick={waCTA}>
            Quiero mi lugar → WhatsApp
          </button>
          <p style={{ fontSize: 11, color: B.muted, textAlign: "center" }}>Te respondemos en menos de 24 horas</p>
        </>
      )}
    </Modal>
  );
}

// ── RESIDENTE MODAL ────────────────────────────────────────────────────
function ResidenteModal({ onClose }) {
  const [form, setForm] = useState({ nombre: "", whatsapp: "", años: "", zona: "", disponibilidad: "" });
  const wa = () => {
    const msg = encodeURIComponent(`Hola, soy residente y quiero unirme a la red GenerIA.\n\nNombre: ${form.nombre}\nAños de experiencia: ${form.años}\nZona: ${form.zona}\nDías disponibles: ${form.disponibilidad}`);
    window.open(`https://wa.me/5215650192332?text=${msg}`, "_blank");
  };
  return (
    <Modal onClose={onClose}>
      <div className="tag tag-b" style={{ marginBottom: 20 }}>Red de residentes GenerIA</div>
      <h3 style={{ fontSize: 22, fontWeight: 800, marginBottom: 12 }}>Gana dinero extra en tu tiempo libre.</h3>
      <p style={{ color: B.muted, fontSize: 14, lineHeight: 1.7, marginBottom: 20 }}>
        Tú pones el conocimiento técnico y el tiempo. GenerIA pone la herramienta, el cliente y el pago.
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: 14, marginBottom: 24 }}>
        <div><label>Nombre</label><input placeholder="Tu nombre" value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} /></div>
        <div><label>WhatsApp</label><input placeholder="+52 55 0000 0000" value={form.whatsapp} onChange={e => setForm({ ...form, whatsapp: e.target.value })} /></div>
        <div>
          <label>¿Cuántos años llevas como residente?</label>
          <select value={form.años} onChange={e => setForm({ ...form, años: e.target.value })}>
            <option value="">Selecciona</option>
            <option>Menos de 2</option><option>2-5</option><option>5-10</option><option>Más de 10</option>
          </select>
        </div>
        <div><label>¿En qué zona trabajas normalmente?</label><input placeholder="Ej. Coyoacán, Tlalpan…" value={form.zona} onChange={e => setForm({ ...form, zona: e.target.value })} /></div>
        <div>
          <label>¿Cuántos días a la semana tienes disponibles?</label>
          <select value={form.disponibilidad} onChange={e => setForm({ ...form, disponibilidad: e.target.value })}>
            <option value="">Selecciona</option>
            <option>1-2 días</option><option>3-4 días</option><option>5+ días</option>
          </select>
        </div>
      </div>
      <button className="btn btn-p" style={{ width: "100%" }} onClick={wa}>Me uno a la red → WhatsApp</button>
    </Modal>
  );
}

// ── OPORTUNIDADES MODAL ────────────────────────────────────────────────
function OportunidadModal({ tipo, onClose }) {
  const cfg = {
    sobrante: { tag: "🟠 Sobrante", title: "Publica tu material sobrante", color: B.orange, wa: "Hola, quiero publicar material sobrante en GenerIA Oportunidades" },
    nuevo: { tag: "🔵 Material nuevo", title: "Ofrece tu material a contratistas activos", color: B.blue, wa: "Hola, quiero publicar material nuevo en GenerIA Oportunidades" },
    innovacion: { tag: "🟣 Innovación", title: "Da a conocer tu desarrollo sin costo", color: "#B085FF", wa: "Hola, quiero publicar mi innovación en GenerIA Oportunidades" },
  }[tipo];

  const wa = () => window.open(`https://wa.me/5215650192332?text=${encodeURIComponent(cfg.wa)}`, "_blank");

  return (
    <Modal onClose={onClose}>
      <div style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "5px 13px", borderRadius: 100, fontSize: 11, fontWeight: 700, background: `${cfg.color}18`, color: cfg.color, border: `1px solid ${cfg.color}44`, marginBottom: 20 }}>{cfg.tag}</div>
      <h3 style={{ fontSize: 22, fontWeight: 800, marginBottom: 12 }}>{cfg.title}</h3>
      <p style={{ color: B.muted, fontSize: 14, lineHeight: 1.7, marginBottom: 24 }}>
        Publicar es siempre gratis. Te conectamos con contratistas activos en tu zona. Solo pagas el 5% cuando cierras el deal — y GenerIA siempre es el intermediario para que todo fluya seguro.
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 28 }}>
        {["Publicar siempre es gratis", "Match automático por material y zona", "Contacto directo solo cuando el deal está cerrado", "GenerIA como intermediario seguro"].map(b => (
          <div key={b} style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 14 }}>
            <span style={{ color: B.green }}>✓</span><span style={{ color: B.text }}>{b}</span>
          </div>
        ))}
      </div>
      <button className="btn btn-p" style={{ width: "100%" }} onClick={wa}>Publicar ahora → WhatsApp</button>
    </Modal>
  );
}

// ── MAIN ───────────────────────────────────────────────────────────────
export default function LandingPage() {
  const [modal, setModal] = useState(null);
  const openModal = (type) => setModal(type);
  const closeModal = () => setModal(null);

  return (
    <>
      <style>{css}</style>

      {/* MODALES */}
      {modal === "video" && <VideoModal onClose={closeModal} />}
      {modal === "contratista" && <ContratistaModal onClose={closeModal} />}
      {modal === "residente" && <ResidenteModal onClose={closeModal} />}
      {modal === "sobrante" && <OportunidadModal tipo="sobrante" onClose={closeModal} />}
      {modal === "nuevo" && <OportunidadModal tipo="nuevo" onClose={closeModal} />}
      {modal === "innovacion" && <OportunidadModal tipo="innovacion" onClose={closeModal} />}

      {/* NAV */}
      <nav style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 100, background: "rgba(6,12,24,.9)", backdropFilter: "blur(20px)", borderBottom: `1px solid ${B.border}`, padding: "0 24px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 58 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img src={GENERIA_LOGO} alt="GenerIA" style={{ width: 32, height: 32, borderRadius: 7, objectFit: "contain" }} />
          <span style={{ fontWeight: 800, fontSize: 16, letterSpacing: "-.02em" }}>Gener<span style={{ color: B.orange }}>IA</span></span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <a href="/oportunidades" style={{ color: B.muted, fontSize: 13, fontWeight: 600, textDecoration: "none", padding: "8px 12px", transition: "color .2s" }} onMouseOver={e => e.target.style.color = B.cyan} onMouseOut={e => e.target.style.color = B.muted}>Oportunidades</a>
          <a href="/login" className="btn btn-s btn-sm" style={{ textDecoration: "none" }}>Iniciar sesión</a>
          <button className="btn btn-p btn-sm" onClick={() => openModal("contratista")}>Me interesa →</button>
        </div>
      </nav>

      {/* HERO */}
      <div className="hero-section" style={{ minHeight: "100vh", display: "flex", alignItems: "center", paddingTop: 58, position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", inset: 0, backgroundImage: `linear-gradient(rgba(0,102,255,.04) 1px,transparent 1px),linear-gradient(90deg,rgba(0,102,255,.04) 1px,transparent 1px)`, backgroundSize: "60px 60px", animation: "gridScroll 10s linear infinite" }} />
        <div style={{ position: "absolute", top: "25%", left: "50%", transform: "translateX(-50%)", width: 700, height: 400, background: `radial-gradient(ellipse,rgba(0,102,255,.1) 0%,transparent 70%)`, pointerEvents: "none" }} />

        <div className="hero-content" style={{ maxWidth: 1080, margin: "0 auto", padding: "80px 24px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 60, alignItems: "center", width: "100%", position: "relative" }}>
          <div>
            <div className="tag tag-b fu d1" style={{ marginBottom: 22 }}>
              <span style={{ width: 6, height: 6, borderRadius: "50%", background: B.green, animation: "blink 1.5s ease-in-out infinite" }} />
              MVP activo · México 2026
            </div>
            <h1 className="fu d2 hero-t" style={{ fontSize: 52, fontWeight: 900, lineHeight: 1.1, letterSpacing: "-.035em", marginBottom: 22 }}>
              Hacer generadores de obra<br />
              dejó de ser un dolor<br />
              punzante en los…<br />
              <span style={{ color: B.orange }}>flujos de caja.</span><br />
              <span style={{ color: B.muted, fontSize: "0.65em", fontWeight: 700, letterSpacing: "0em" }}>De nada.</span>
            </h1>
            <p className="fu d3" style={{ fontSize: 16, color: B.muted, lineHeight: 1.75, marginBottom: 32, maxWidth: 460 }}>
              Toma la foto en obra. PDF listo para tramitar. Sin papel, sin Excel, sin AutoCAD, sin rollos.
            </p>
            <div className="fu d4 hero-buttons" style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <button className="btn btn-p" onClick={() => openModal("contratista")}>Me interesa</button>
              <button className="btn btn-s" onClick={() => openModal("video")}>Ver demo ▶</button>
            </div>
          </div>
          <div className="fu d3 hide-m">
            <PhoneH />
          </div>
        </div>
      </div>

      <div className="div" />

      {/* EL PROBLEMA */}
      <div className="sec">
        <div style={{ textAlign: "center", maxWidth: 600, margin: "0 auto 56px" }}>
          <div className="tag tag-o" style={{ marginBottom: 18 }}>El problema real</div>
          <h2 style={{ fontSize: 38, fontWeight: 800, lineHeight: 1.15, letterSpacing: "-.025em", marginBottom: 16 }}>
            El problema no es la obra.<br />Es cobrarla.
          </h2>
          <p style={{ color: B.muted, fontSize: 16, lineHeight: 1.7 }}>
            Eliminamos la barrera más antigua del contratista para tramitar sus pagos.
          </p>
        </div>
        <div className="grid3">
          {[
            { icon: "✏️", title: "Del campo al papel", desc: "Dibujas a mano lo que ya mediste en obra. Primera captura, primer riesgo de error." },
            { icon: "💻", title: "Del papel al AutoCAD al Excel", desc: "Vuelves a capturar dos veces más. Cada pase es una oportunidad de equivocarte." },
            { icon: "💸", title: "Un error en cualquier paso", desc: "Y tu generador regresa. Tu pago se puede ir semanas — o meses." },
          ].map(({ icon, title, desc }) => (
            <div className="card" key={title}>
              <div style={{ fontSize: 32, marginBottom: 14 }}>{icon}</div>
              <div style={{ fontSize: 17, fontWeight: 700, marginBottom: 8 }}>{title}</div>
              <div style={{ fontSize: 13, color: B.muted, lineHeight: 1.65 }}>{desc}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="div" />

      {/* CÓMO FUNCIONA */}
      <div className="sec">
        <div style={{ textAlign: "center", maxWidth: 520, margin: "0 auto 56px" }}>
          <div className="tag tag-b" style={{ marginBottom: 18 }}>Cómo funciona</div>
          <h2 style={{ fontSize: 38, fontWeight: 800, lineHeight: 1.15, letterSpacing: "-.025em" }}>
            4 pasos.<br />Tu generador en minutos.
          </h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 56, alignItems: "center" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            {[
              { n: "01", t: "Toma la foto en obra", d: "Desde tu teléfono o iPad, directo en campo. Sin preparativos.", c: B.blue },
              { n: "02", t: "Marca la figura", d: "Arrastra y posiciona la etiqueta sobre la foto. Con tu dedo, en segundos.", c: B.cyan },
              { n: "03", t: "Captura las medidas", d: "Ingresa las dimensiones reales. Sin dibujos, sin AutoCAD, sin Excel.", c: B.orange },
              { n: "04", t: "PDF listo para tramitar", d: "Figuras, tablas y acumulados en un PDF profesional. Un toque, cero rechazos.", c: B.green },
            ].map(({ n, t, d, c }) => (
              <div key={n} style={{ display: "flex", gap: 16 }}>
                <div style={{ minWidth: 40, height: 40, borderRadius: 10, background: `${c}18`, border: `1px solid ${c}44`, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Space Mono", fontSize: 10, fontWeight: 700, color: c }}>{n}</div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 4 }}>{t}</div>
                  <div style={{ fontSize: 13, color: B.muted, lineHeight: 1.6 }}>{d}</div>
                </div>
              </div>
            ))}
          </div>
          <div className="hide-m"><PDFMock /></div>
        </div>
      </div>

      <div className="div" />

      {/* TESTIMONIO */}
      <div style={{ padding: "80px 24px", background: "rgba(0,102,255,.04)", textAlign: "center" }}>
        <div style={{ maxWidth: 620, margin: "0 auto" }}>
          <div style={{ fontSize: 44, marginBottom: 20 }}>🏟️</div>
          <blockquote style={{ fontSize: 32, fontWeight: 800, letterSpacing: "-.02em", marginBottom: 16 }}>
            "¿Así de fácil?"
          </blockquote>
          <p style={{ color: B.muted, fontSize: 15, marginBottom: 8 }}>
            La reacción de los residentes la primera vez que ven GenerIA.
          </p>
        </div>
      </div>

      <div className="div" />

      {/* PARA QUIÉN — Contratista principal */}
      <div className="sec">
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <h2 style={{ fontSize: 36, fontWeight: 800, letterSpacing: "-.025em" }}>¿Para quién es GenerIA?</h2>
        </div>
        {/* Contratista — card grande */}
        <div style={{ background: B.bgCard, border: `1px solid ${B.border}`, borderRadius: 16, padding: 40, marginBottom: 20, display: "flex", gap: 40, alignItems: "center", cursor: "pointer" }} onClick={() => openModal("contratista")}>
          <div style={{ fontSize: 60 }}>🏗️</div>
          <div style={{ flex: 1 }}>
            <div className="tag tag-g" style={{ marginBottom: 12 }}>Early Adopter disponible</div>
            <div style={{ fontSize: 26, fontWeight: 800, marginBottom: 8 }}>Soy contratista de obra pública</div>
            <div style={{ fontSize: 15, color: B.muted, lineHeight: 1.65, marginBottom: 20 }}>Quiero controlar mi obra y tramitar mis pagos sin el caos de siempre. Sin papel, sin AutoCAD, sin Excel.</div>
            <button className="btn btn-p btn-sm" onClick={e => { e.stopPropagation(); openModal("contratista"); }}>Me interesa →</button>
          </div>
        </div>

        {/* Residente — card pequeña secundaria */}
        <div style={{ background: "rgba(13,21,38,.5)", border: `1px solid ${B.border}`, borderRadius: 12, padding: 24, display: "flex", gap: 20, alignItems: "center", cursor: "pointer", opacity: 0.85 }} onClick={() => openModal("residente")}>
          <div style={{ fontSize: 36 }}>🦺</div>
          <div style={{ flex: 1 }}>
            <div className="tag tag-b" style={{ marginBottom: 8 }}>Red de residentes</div>
            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>Soy residente y quiero ganar dinero extra</div>
            <div style={{ fontSize: 13, color: B.muted, marginBottom: 12 }}>Úsate tu tiempo libre documentando obra con GenerIA. Tú pones el conocimiento, nosotros ponemos el cliente.</div>
            <button className="btn btn-s btn-sm" onClick={e => { e.stopPropagation(); openModal("residente"); }}>Quiero unirme →</button>
          </div>
        </div>
      </div>

      <div className="div" />

      {/* OPORTUNIDADES */}
      <div className="sec" id="oportunidades">
        <div style={{ textAlign: "center", maxWidth: 620, margin: "0 auto 56px" }}>
          <div className="tag tag-o" style={{ marginBottom: 18 }}>GenerIA Oportunidades</div>
          <h2 style={{ fontSize: 38, fontWeight: 800, lineHeight: 1.15, letterSpacing: "-.025em", marginBottom: 16 }}>
            El marketplace de materiales<br />de construcción.
          </h2>
          <p style={{ color: B.muted, fontSize: 16, lineHeight: 1.7 }}>
            Vende tu sobrante, ofrece material nuevo o da a conocer tu innovación — te conectamos con contratistas activos en tu zona. Publicar siempre es gratis. Solo pagas cuando cierras.
          </p>
        </div>
        <div className="grid3">
          {[
            { tipo: "sobrante", icon: "🟠", title: "Sobrante", desc: "Material de obra que te quedó. Precio de remate, comprador en tu zona.", tag: "tag-o", btn: "Tengo sobrante →" },
            { tipo: "nuevo", icon: "🔵", title: "Material nuevo", desc: "Ferreterías y proveedores que quieren llegar directo a contratistas activos.", tag: "tag-b", btn: "Ofrezco material →" },
            { tipo: "innovacion", icon: "🟣", title: "Innovación", desc: "Desarrollaste algo nuevo para construcción. Da a conocerlo sin costo.", tag: "tag-p", btn: "Presento mi producto →" },
          ].map(({ tipo, icon, title, desc, tag, btn }) => (
            <div className="card" key={tipo} style={{ cursor: "pointer" }} onClick={() => openModal(tipo)}>
              <div style={{ fontSize: 32, marginBottom: 14 }}>{icon}</div>
              <div className={`tag ${tag}`} style={{ marginBottom: 12 }}>{title}</div>
              <div style={{ fontSize: 14, color: B.muted, lineHeight: 1.65, marginBottom: 20 }}>{desc}</div>
              <button className="btn btn-s btn-sm" style={{ width: "100%" }}>{btn}</button>
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: 32, padding: 20, background: "rgba(255,107,0,.06)", border: `1px solid rgba(255,107,0,.18)`, borderRadius: 10, maxWidth: 500, margin: "32px auto 0" }}>
          <span style={{ color: B.orange, fontSize: 14, fontWeight: 600 }}>Publicar es siempre gratis — solo 5% al cerrar el deal.</span>
        </div>
      </div>

      <div className="div" />

      {/* EARLY ADOPTER */}
      <div style={{ padding: "96px 24px", background: "rgba(0,102,255,.04)" }}>
        <div style={{ maxWidth: 680, margin: "0 auto", textAlign: "center" }}>
          <div className="tag tag-g" style={{ marginBottom: 24 }}>
            <span style={{ width: 6, height: 6, borderRadius: "50%", background: B.green, animation: "blink 1s ease-in-out infinite" }} />
            Solo 10 lugares
          </div>
          <h2 style={{ fontSize: 42, fontWeight: 900, lineHeight: 1.15, letterSpacing: "-.03em", marginBottom: 20 }}>
            Los primeros 10<br />
            <span style={{ color: B.blue }}>construyen GenerIA con nosotros.</span>
          </h2>
          <p style={{ color: B.muted, fontSize: 16, lineHeight: 1.75, marginBottom: 36 }}>
            18 meses al precio más bajo + un feature a la medida de tu operación, sin costo adicional. Después de estos 10 lugares, eso ya no es parte del trato.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: 8, marginBottom: 12 }}>
            {Array.from({ length: 10 }).map((_, i) => (
              <div key={i} style={{ width: 36, height: 8, borderRadius: 4, background: B.border }} />
            ))}
          </div>
          <div style={{ fontSize: 13, color: B.muted, marginBottom: 36 }}>Primeros cupos disponibles — solo 10 lugares</div>
          <button className="btn btn-p" style={{ fontSize: 16, padding: "18px 48px" }} onClick={() => openModal("contratista")}>
            Quiero mi lugar →
          </button>
        </div>
      </div>

      {/* FOOTER */}
      <div className="div" />
      <footer style={{ padding: "36px 24px", textAlign: "center" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 12 }}>
          <img src={GENERIA_LOGO} alt="GenerIA" style={{ width: 26, height: 26, borderRadius: 6, objectFit: "contain" }} />
          <span style={{ fontWeight: 800, fontSize: 14 }}>Gener<span style={{ color: B.orange }}>IA</span></span>
          <span style={{ color: B.muted, fontSize: 13 }}>by TANGIBLE Tech</span>
        </div>
        <p style={{ color: B.muted, fontSize: 12 }}>
          © 2026 TANGIBLE Tech · Ciudad de México ·{" "}
          <a href="#" style={{ color: B.muted, textDecoration: "underline" }}>Aviso de Privacidad</a>
        </p>
      </footer>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/5215650192332"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 999,
          display: "flex",
          alignItems: "center",
          gap: 10,
          background: "#25D366",
          color: "#fff",
          padding: "12px 20px",
          borderRadius: 50,
          fontFamily: "Sora, sans-serif",
          fontWeight: 700,
          fontSize: 14,
          textDecoration: "none",
          boxShadow: "0 4px 20px rgba(37,211,102,.4)",
          transition: "transform .2s, box-shadow .2s",
        }}
        onMouseOver={(e) => { e.currentTarget.style.transform = "scale(1.05)"; e.currentTarget.style.boxShadow = "0 6px 30px rgba(37,211,102,.5)"; }}
        onMouseOut={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = "0 4px 20px rgba(37,211,102,.4)"; }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
        Escríbenos
      </a>
    </>
  );
}
